import type { AIWatermarkColor } from '~/amplienceTypes/partials/exported/responsive-image-schema';

export const AI_AMPLIENCE_ICON_ALT_PATTERN = /\[Ai\]|(?:^|\s)AI[\s-]/i;

const AI_AMPLIENCE_IMAGE_URL_ENDS_WITH = '-AI';
const AI_CLOUDINARY_TRANSFORMATION_PARAM = /\/t_ai[^/]*(?=\/)/gi;

export type ImageLinkLike = {
  name?: string;
};

export type ShouldShowAiIconParams = {
  alt?: string;
  imageLinks?: Array<ImageLinkLike | undefined>;
  aiWatermarkColor?: AIWatermarkColor;
};

const isImageLinkLike = (value: unknown): value is ImageLinkLike =>
  !!value && typeof value === 'object' && 'name' in value;

const getAmplienceImageUrl = (imageLink?: ImageLinkLike): string | undefined =>
  isImageLinkLike(imageLink) && imageLink.name ? encodeURI(imageLink.name) : undefined;

const getAmplienceImageUrls = (imageLinks?: Array<ImageLinkLike | undefined>): string[] =>
  imageLinks?.map(getAmplienceImageUrl).filter((url): url is string => !!url) ?? [];

export const shouldShowAiIconFromImageAlt = (alt?: string): boolean =>
  AI_AMPLIENCE_ICON_ALT_PATTERN.test(alt ?? '');

export const shouldShowAiIconFromImageUrl = (url?: string): boolean =>
  (url ?? '').endsWith(AI_AMPLIENCE_IMAGE_URL_ENDS_WITH);

export const shouldShowAiIcon = ({ alt, imageLinks }: ShouldShowAiIconParams): boolean =>
  shouldShowAiIconFromImageAlt(alt) ||
  [...getAmplienceImageUrls(imageLinks)].some(shouldShowAiIconFromImageUrl);

export const removeAiWatermark = (url?: string) =>
  url?.replace(AI_CLOUDINARY_TRANSFORMATION_PARAM, '');
